import siteService from "@/services/sites.service";
import filtersService from "@/services/filters.service.js";

export default {
  namespaced: true,
  state: {
    sites: []
  },
  mutations: {
    setSites(state, sites) {
      state.sites = sites;
    }
  },
  actions: {
    async load({ commit }) {
      commit("setSites", await siteService.findAll());
    }
  },
  getters: {
    sites: state => {
      return state.sites;
    },
    owners: state => {
      const owners = [];
      state.sites.forEach(site => {
        if (site.owner && owners.indexOf(site.owner.toUpperCase()) === -1) {
          owners.push(site.owner.toUpperCase());
        }
      });
      return owners;
    },
    filteredSites: (state, _getters, rootState) => {
      const sites = [];

      state.sites.forEach(site => {
        if (filtersService.doesSiteMatchesFilters(site, rootState.filters)) {
          sites.push(site);
        }
      });

      return sites;
    }
  }
};
